/**
 * Validación de CUI (Código Único de Identificación, el número del DPI guatemalteco).
 * Portado VERBATIM desde `apps/web-real-estate/src/shared/utils/dpi.lib.ts` (que estaba
 * duplicado también en `apps/api-real-estate/src/renap/utils/cui.utils.ts`).
 * Este paquete es ahora la fuente canónica — front y back deben importar de aquí.
 */
export const cuiIsValid = (cui: string): boolean => {
  if (!cui) return false

  const cuiRegExp = /^[0-9]{4}\s?[0-9]{5}\s?[0-9]{4}$/
  if (!cuiRegExp.test(cui)) return false

  const numberId = cui.replace(/\s/, '')

  const depto = parseInt(numberId.substring(9, 11), 10)
  const muni = parseInt(numberId.substring(11, 13))
  const numero = numberId.substring(0, 8)
  const verificador = parseInt(numberId.substring(8, 9))

  // Cantidad de municipios por departamento (códigos 01-22).
  const munisPorDepto = [
    17, 8, 16, 16, 13, 14, 19, 8, 24, 21, 9, 30, 32, 21, 8, 17, 14, 5, 11, 11, 7, 17
  ]

  if (depto === 0 || muni === 0) return false
  if (depto > munisPorDepto.length) return false
  if (muni > munisPorDepto[depto - 1]) return false

  // Verificación del correlativo por complemento 11.
  let total = 0
  for (let i = 0; i < numero.length; i++) {
    total += parseInt(numero[i]) * (i + 2)
  }
  const modulo = total % 11

  return modulo === verificador
}
